<template>
  <section class="t-mt-8">
    <div class="t-flex t-items-center" role="heading">
      <h2 class="t-text-2xl t-font-medium t-text-gray-900 t-mb-1 t-inline-block">
        Off Site Trackers
      </h2>
      <span v-tooltip="`These are the Freightmates trackers that have been sent to your customers. It would be great if you could help us help your customers to reuse, recycle or return these Freightmates.`">
        <i class="fa fa-question-circle d-inline" aria-hidden="true" style="margin-left: 0.25rem; white-space: pre-line"/>
      </span>
    </div>

    <div
      v-if="isLoadingOffSite"
      class="t-mt-8 t-flex t-justify-center"
    >
      <p class="t-text-2xl">Loading Trackers...</p>
    </div>

    <div
      v-if="!isLoadingOffSite && !offSiteTrackers.length"
      class="t-mt-8 t-flex t-justify-center"
    >
      <p class="t-text-1xl">No Trackers Set Yet</p>
    </div>

    <base-tracking-table
      v-show="!isLoadingOffSite && offSiteTrackers.length"
      :trackers="offSiteTrackers"
      :column-headers="offSiteColumnHeaders"
    >
      <template #booking="{ bookingId }">
        <div class="t-py-4 t-text-sm t-relative">
          <div class="t-grid t-grid-rows-1 t-grid-cols-2 t-visible t-block md:t-hidden">
            <p>Recent Booking</p>
            <p>{{ bookingId }}</p>
          </div>
          <p class="t-hidden md:t-block">
            {{ bookingId }}
          </p>
        </div>
      </template>

      <template #recipient="{ tracker }">
        <div class="t-py-4 t-text-sm t-relative hover-trigger">
          <div class="t-grid t-grid-rows-1 t-grid-cols-2 t-visible t-block md:t-hidden">
            <p>Recipient</p>
            <p>{{ tracker.recipient }}</p>
          </div>
          <p class="t-hidden md:t-inline">
            {{ tracker.recipient }}
          </p>

          <div class="t-absolute t-px-2 hover-target t-bg-white t-z-50 t-border t-border-gray-600 t-text-black t-text-sm t-rounded t-py-1 t-bottom-full">
            {{ tracker.currentLocation }}
          </div>
        </div>
      </template>

      <template #options>
        <div v-if="false" class="t-py-4 t-text-sm">
          <button
            class="t-flex t-px-1 t-text-center t-rounded-md t-text-blue-600 t-font-medium"
            @click="modal.isShowing = !modal.isShowing"
          >
            Contact
          </button>
        </div>
      </template>
    </base-tracking-table>

    <modal
      v-if="modal.isShowing"
      @closed="modal.isShowing = !modal.isShowing"
    >
      <template #title>
        <div class="t-text-xl t-font-medium">
          Contact
        </div>
      </template>
      <template>
        <p class="t-p-4 t-tracking-wide">

        </p>
      </template>
    </modal>
  </section>
</template>

<script>
import BaseTrackingTable from "./BaseTrackingTable";

export default {
  name: 'OffSiteTrackersTab',
  description: '',
  components: {
    BaseTrackingTable
  },
  props: {
    mapRawTrackers: {
      type: Function, required: true,
    }
  },
  data() {
    return {
      offSiteTrackers: [],
      isLoadingOffSite: false,
      offSiteColumnHeaders: ['Freightmate', 'Recipient', 'Last Detected', 'Last Movement', 'Recent Booking', '', ''],
      modal: {
        isShowing: false
      }
    }
  },
  created() {
    this.loadUnlinkedOffSite();
  },
  methods: {
    async loadUnlinkedOffSite() {
      try {
        this.isLoadingOffSite = true;
        let res = await axios.get('/send-freight/tracker/unlink/offsite');
        let data = Object.values(res.data);
        this.offSiteTrackers = this.mapRawTrackers(data);
      } catch (e) {
        console.error(e)
      } finally {
        this.isLoadingOffSite = false;
      }
    },
  }
}
</script>

<style scoped>
.hover-trigger .hover-target {
  display: none;
}

.hover-trigger:hover .hover-target {
  display: block;
}
</style>
